import { ComponentType, useEffect, useState } from 'react';

import { useAppSelector, useOnboardingTask } from '@/hooks';

export const withOnboardingGuard = <P extends Record<string, unknown>>(Component: ComponentType<P>) => (
  function OnboardingGuard(props: P) {
    const { company } = useAppSelector(state => state.auth);
    const { redirectToOfferOrDashboard } = useOnboardingTask();
    const [activated, setActivated] = useState(false);

    const checkIfCompletedOnboarding = () => {
      const isCompletedOnSettings =
        company?.companySettings?.custom?.completedOnBoarding === 'yes' ||
        company?.companySettings?.custom?.completedOnBoarding;

      return isCompletedOnSettings;
    };


    useEffect(() => {
      if (!company) return;

      if (!checkIfCompletedOnboarding()) {
        setActivated(true);
      } else {
        redirectToOfferOrDashboard();
      }
    }, [company]);

    if (!company || !activated) {
      return null;
    }

    return <Component { ...props } />;
  }
);
